import React, { useEffect, useState, useRef } from 'react'
import { Link, NavLink } from 'react-router-dom'
import { useStyles } from './NavbarStyle'
import { useHistory } from 'react-router-dom'

//Redux
import { useSelector, useDispatch } from 'react-redux'
import allActions from '../../redux/actions/user'

//Material UI Imports
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Button from '@material-ui/core/Button'
import AccountCircleIcon from '@material-ui/icons/AccountCircle'
import Container from '@material-ui/core/Container'
import AssignmentTurnedInOutlinedIcon from '@material-ui/icons/AssignmentTurnedInOutlined'
import SportsTennisIcon from '@material-ui/icons/SportsTennis'
import NoteOutlinedIcon from '@material-ui/icons/NoteOutlined'
import ClickAwayListener from '@material-ui/core/ClickAwayListener'
import Grow from '@material-ui/core/Grow'
import Paper from '@material-ui/core/Paper'
import Popper from '@material-ui/core/Popper'
import MenuItem from '@material-ui/core/MenuItem'
import MenuList from '@material-ui/core/MenuList'
import PersonIcon from '@material-ui/icons/Person'
import ExitToAppIcon from '@material-ui/icons/ExitToApp'
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline'
import logo from '../../assets/images/logo_nice.png'
import MenuIcon from '@material-ui/icons/Menu'


import Drawer from '@material-ui/core/Drawer'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import IconButton from '@material-ui/core/IconButton'
import ContactSupportOutlinedIcon from '@material-ui/icons/ContactSupportOutlined'
import CalendarTodayIcon from '@material-ui/icons/CalendarToday'
import EventAvailableIcon from '@material-ui/icons/EventAvailable'

import logoAnimanice from '../../assets/images/logo.png'

const nav = [
  { name: 'MES ACTIVITES',url: '/mes-activites',icon: <AssignmentTurnedInOutlinedIcon />, },
  { name: 'MES RESERVATIONS TENNIS',url: '/reservation-tennis',icon: <SportsTennisIcon />, },
  { name: 'MES RENDEZ-VOUS',url: '/mes-rendez-vous',icon: <EventAvailableIcon />, },
  { name: 'SOUSCRIPTION', url: '/souscription', icon: <AddCircleOutlineIcon />, },
  { name: 'PRISE DE RENDEZ-VOUS', url: '/rendez-vous', icon: <CalendarTodayIcon />, },
  // { name: 'SOUSCRIPTION', url: '/new-souscription', icon: <AddCircleOutlineIcon />, },
  //{ name: 'Contact', url: '/contact', icon: <ContactSupportOutlinedIcon />, },
  // { name: 'MES COURS EN LIGNE', url: '/cours', icon: <NoteOutlinedIcon /> },
]

export default function Navbar() {
  const classes = useStyles()
  const state = useSelector((state) => state)
  const [hasPhoto, setHasPhoto] = useState(false)
  const dispatch = useDispatch()
  const [drawerOpen, setDrawerOpen] = useState(false)
  const history = useHistory()

  useEffect(() => {
    const p = state.user?.photo
    if (p === '' || p === undefined) setHasPhoto(false)
    else setHasPhoto(true)
  }, [state])

  const [open, setOpen] = useState(false)
  const anchorRef = useRef(null)

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen)
  }

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target))
      return

    setOpen(false)
  }

  const prevOpen = useRef(open)
  useEffect(() => {
    if (prevOpen.current === true && open === false)
      anchorRef.current.focus()

    prevOpen.current = open

  }, [open])

  useEffect(() => {
    if (drawerOpen) window.scrollTo(0, 0)
  }, [drawerOpen])

  const logout = () => {
    dispatch(allActions.logOut())
  }

  function goTo(url) {
    history.push(url)
    setDrawerOpen(false)
  }

  function filterNavItems (item) {
    if (item.url === '/rendez-vous' && state.interruptionRendezVous) {
      return false
    }
    return !(item.url === '/reservation-tennis' && state.interruptionTennis);

  }
  
  return (
    <div>
      <Drawer
        anchor={'left'}
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
      >
        <List>
          {nav.filter(filterNavItems).map((item, index) => (
            <ListItem button key={index} onClick={() => goTo(item.url)}>
              <ListItemIcon style={{ color: '#2196f3' }}>{item.icon}</ListItemIcon>
              <ListItemText
                primary={item.name}
                className={classes.drawer}
              />

            </ListItem>
          ))}
        </List>
      </Drawer>
      <AppBar position="static">
        <Toolbar className={classes.root}>
          {state.loggedIn && 
            <IconButton onClick={() => setDrawerOpen(!drawerOpen)} className={classes.burger}><MenuIcon /></IconButton>
          }
          <div className={classes.title}>
            <img
              src={logo}
              style={{ width: '60px', marginRight: '20px' }}
              alt="Ville de Nice"
            />
            <Link to="/">
              <img
                src={logoAnimanice}
                className={classes.img}
                alt="AnimaniceLogo"
              />
            </Link>
          </div>

          {state.loggedIn && (
            <Container className={classes.container}>
              {nav.filter(filterNavItems).map((item, index) => {
                return (
                  <NavLink
                    className={classes.underline}
                    key={index}
                    to={item.url}
                    activeClassName="link-active"
                    style={{
                      textDecoration: 'none',
                      color: '#2196f3',
                      marginRight: 25,
                    }}
                  >
                    {' '}{item.icon} {item.name}{' '}
                  </NavLink>
                )
              })}
            </Container>
          )}

          {state.loggedIn && (
            <div>
              <Button
                ref={anchorRef}
                aria-controls={
                  open ? 'menu-list-grow' : undefined
                }
                aria-haspopup="true"
                color="primary"
                onClick={handleToggle}
                className={classes.menuButton}
              >
                {hasPhoto ? (
                  <div
                    style={{
                      backgroundImage: `url(${state.user.photo})`,
                    }}
                    className={classes.photo}
                  />
                ) : (
                  <AccountCircleIcon />
                )}
                <p style={{ marginLeft: '8px' }} className={classes.truncate} >
                  {state.user?.prenom}{' '}
                  {state.user?.nom?.substring(0, 1)}
                </p>
              </Button>

              <Popper
                style={{ zIndex: 1001 }}
                open={open}
                anchorEl={anchorRef.current}
                role={undefined}
                transition
              >
                {({ TransitionProps, placement }) => (
                  <Grow
                    {...TransitionProps}
                    style={{
                      transformOrigin:
                        placement === 'bottom'
                          ? 'center top'
                          : 'center bottom',
                    }}
                  >
                    <Paper>
                      <ClickAwayListener  onClickAway={handleClose}>
                        <MenuList autoFocusItem={open} id="menu-list-grow">
                          <Link to="/donnees-personnelles" className={classes.userLink}>
                            <MenuItem onClick={handleClose} >
                              <PersonIcon
                                className={classes.materialIcon}
                                color="action"
                              />
                                Mes infos
                            </MenuItem>
                          </Link>
                          <Link to="/contact" className={classes.userLink}>
                            <MenuItem onClick={handleClose}>
                              <ContactSupportOutlinedIcon
                                className={
                                  classes.materialIcon
                                }
                                color="action"
                              />
                              Contact
                            </MenuItem>
                          </Link>
                          <Link to="/" className={classes.userLink}>
                            <MenuItem onClick={logout}>
                              <ExitToAppIcon
                                className={
                                  classes.materialIcon
                                }
                                color="action"
                              />
                                Se déconnecter
                            </MenuItem>
                          </Link>
                        </MenuList>
                      </ClickAwayListener>
                    </Paper>
                  </Grow>
                )}
              </Popper>
            </div>
          )}
        </Toolbar>
      </AppBar>
    </div>
  )
}
